import * as classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ta from 'time-ago';
import { getAsset } from '../../selectors';
import AssetPicker from '../AssetPicker';
import Box from '../layout/Box';
import Button from '../widgets/Button';
import './styles.scss';

const PriorityContentView = ({priorityMessage, messageAsset, onChange, onActivate, onDeactivate}) => {
  const isActive = !!priorityMessage && priorityMessage.activated_on;
  const {duration, activated_on} = priorityMessage || {duration: 15, activated_on: null};

  return (
    <Box className={classnames('priority-message', {'active': isActive})} direction="column">
      <Box direction="row" alignItems="baseline" justifyContent="space-between">
        <h5>Priority Announcement</h5>
        {isActive && <span>Active since {ta.ago(activated_on)}</span>}
      </Box>
      <Box direction="row"
           justifyContent="space-between"
           alignItems="flex-end">
        <label htmlFor="durationSelect">Duration:
          <select name="durationSelect" id="durationSelect"
                  value={duration / 1000}
                  style={{maxWidth: 180}}
                  onChange={({currentTarget}) => onChange({duration: currentTarget.value * 1000})}>
            <option value="0">Indefinite</option>
            <option value="15">15 minutes</option>
            <option value="30">30 minutes</option>
            <option value="45">45 minutes</option>
            <option value="60">60 minutes</option>
          </select>
        </label>
        <label htmlFor="">Message:
          <AssetPicker selected={messageAsset}
                       onSelectAsset={asset => onChange({message: asset.id})}/>
        </label>
        {isActive
          ? <Button onClick={onDeactivate} className="alert">Deactivate</Button>
          : <Button onClick={messageAsset && onActivate}>Activate</Button>}
      </Box>
    </Box>
  );
};

PriorityContentView.propTypes = {
  priorityMessage: PropTypes.shape({
    duration: PropTypes.number,
    message: PropTypes.number,
  }),
  messageAsset: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  onActivate: PropTypes.func.isRequired,
  onDeactivate: PropTypes.func.isRequired,
};

export default connect((state, props) => ({
  messageAsset: getAsset(state, parseInt(props.priorityMessage && props.priorityMessage.message, 10)),
}))(PriorityContentView);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/PriorityMessageView/index.js